module.exports = __webpack_public_path__ + "static/media/pp_logo.54f8954f.svg";